import { useState, useEffect } from 'react';
import { Plus } from 'lucide-react';
import { META, ROUTES } from './data';
// Dentist — clinical white header with cyan rule. Patient-record style nav.
export default function Header({ page, setPage }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', h, { passive: true });
    return () => window.removeEventListener('scroll', h);
  }, []);
  return (
    <header className={`sticky top-0 z-40 bg-[#F8FAFB] transition-all duration-500 ${scrolled ? 'border-b border-[#1B7A8C]/20 py-2' : 'py-4'}`}>
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 flex items-center justify-between gap-6">
        <button onClick={() => setPage('home')} className="flex items-center gap-3" data-testid="dent-logo">
          <div className="w-8 h-8 rounded-full bg-[#1B7A8C] flex items-center justify-center"><Plus className="w-4 h-4 text-white" strokeWidth={2.5} /></div>
          <div>
            <p className="font-serif text-2xl text-[#0A2E3C] leading-tight">{META.brand}</p>
            <p className="font-mono text-[8px] tracking-[0.4em] uppercase text-[#1B7A8C]">{META.tag}</p>
          </div>
        </button>
        <nav className="hidden lg:flex items-center gap-1 bg-white border border-[#1B7A8C]/15 rounded-full p-1">
          {ROUTES.map(r => (
            <button key={r.id} onClick={() => setPage(r.id)} data-testid={`dent-nav-${r.id}`}
              className={`px-4 py-1.5 rounded-full font-mono text-[10px] tracking-[0.22em] uppercase transition-colors ${page === r.id ? 'bg-[#1B7A8C] text-white' : 'text-[#0A2E3C]/65 hover:text-[#0A2E3C]'}`}>
              {r.label}
            </button>
          ))}
        </nav>
        <button onClick={() => setPage('book')} data-testid="dent-cta-book" className="bg-[#E08672] text-white px-4 py-2 font-mono text-[10px] tracking-[0.25em] uppercase hover:bg-[#0A2E3C] transition-colors">Book →</button>
      </div>
    </header>
  );
}
